<template>
  <UISkeleton v-if="loading" rounded class="account-connector-info__skeleton" />
  <UIAccountInfo v-else-if="account" v-bind="{ account, connector }">
    <template v-if="connector" #connector>
      <ConnectorActions :connector size="sm" hide-actions />
    </template>
  </UIAccountInfo>
  <UILayoutNoData v-else inline hide-question-icon />
</template>

<script setup lang="ts">
import { LinkedDataAccount, LinkedDataConnector } from '@types'

import { UIAccountInfo, UILayoutNoData } from '@ui/core'
import { UISkeleton } from '@ui/skeletons'
import ConnectorActions from '@/modules/ConnectorActions/ConnectorActions.vue'

type Props = {
  account?: LinkedDataAccount
  connector?: LinkedDataConnector
  loading?: boolean
}
defineProps<Props>()
</script>

<style>
.account-connector-info {
  &__skeleton {
    @apply h-28;
  }
}
</style>
